import { render, staticRenderFns } from "./ManuallySaveAddress.vue?vue&type=template&id=4fb5f058&scoped=true"
import script from "./ManuallySaveAddress.vue?vue&type=script&lang=js"
export * from "./ManuallySaveAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb5f058",
  null
  
)

export default component.exports